<template>
  <footer aria-label="Footer">
    <!-- Top footer -->
    <div
      v-if="!compact"
      class="bg-[color:var(--color-footer-top-bg)] text-[color:var(--color-footer-top-text)] md:flex print:hidden"
    >
      <div
        class="container mx-auto grid max-w-screen-xl grid-cols-1 gap-4 py-4 md:grid-cols-2 md:py-12 lg:grid-cols-4 xl:grid-cols-5"
      >
        <!-- Logo column -->
        <div class="xl:block">
          <VcImage :src="$cfg.logo_inverted_image" :alt="$context.storeName" class="h-10" lazy />

          <div class="mt-2 flex flex-wrap">
            <SocialLinks footer />
          </div>

          <template v-if="storeId === 'HerasBE'">
            <iframe
              frameborder="1"
              allowtransparency="true"
              src="https://www.kiyoh.com/retrieve-widget.html?color=dark&allowTransparency=true&button=false&lang=nl&tenantId=98&locationId=1078541"
              width="200"
              height="100"
            >
            </iframe>
          </template>
        </div>

        <!-- Column 1 -->
        <div v-if="footerListLeft">
          <div class="mb-3 text-lg font-bold text-primary">
            {{ $t("custom.footer.left") }}
          </div>
          <div class="flex flex-col space-y-3">
            <FooterLink v-for="item in footerListLeft" :key="item.id" :title="item.title" :to="item.route!" />
          </div>
        </div>

        <!-- Column 2 -->
        <div v-if="footerListCenterLeft">
          <div class="mb-3 text-lg font-bold text-primary">
            {{ $t("custom.footer.left_center") }}
          </div>
          <div class="flex flex-col space-y-3">
            <FooterLink v-for="item in footerListCenterLeft" :key="item.id" :title="item.title" :to="item.route!" />
          </div>
        </div>

        <!-- Column 3 -->
        <div v-if="footerListCenterRight">
          <div class="mb-3 text-lg font-bold text-primary">
            {{ $t("custom.footer.right_center") }}
          </div>
          <div class="flex flex-col space-y-3">
            <FooterLink v-for="item in footerListCenterRight" :key="item.id" :title="item.title" :to="item.route!" />
          </div>
        </div>

        <!-- Column 4 -->
        <div>
          <div class="mb-3 text-lg font-bold text-primary">
            {{ $t("custom.footer.right") }}
          </div>

          <div v-if="footerListRight" class="flex flex-col space-y-3">
            <FooterLink v-for="item in footerListRight" :key="item.id" :title="item.title" :to="item.route!" />
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom footer -->
    <div
      class="flex border-t border-[color:var(--color-header-footer-border)] bg-[color:var(--color-footer-bottom-bg)] text-base text-[color:var(--color-footer-bottom-text)]"
    >
      <div
        class="container mx-auto flex min-h-[50px] max-w-screen-xl flex-col justify-center py-5 sm:flex-row sm:items-center sm:justify-between md:py-2"
      >
        <div v-if="footerListBottom" class="flex flex-col sm:flex-row">
          <FooterLink v-for="item in footerListBottom" :key="item.id" :title="item.title" :to="item.route!" />
        </div>

        <div>{{ "&copy;" + new Date().getFullYear() }} {{ $t("shared.layout.footer.copyright") }}</div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useNavigations } from "@/core/composables";
import { SocialLinks } from "@/shared/layout";
import FooterLink from "../_internal/footer-link.vue";
import { PasswordTips, usePasswordRequirements, useUser } from "@/shared/account";
import { globals } from "@/core/globals";

interface IProps {
  compact?: boolean;
}

const props = defineProps<IProps>();
const { storeId } = globals;

const {
  footerListLeft,
  footerListCenterLeft,
  footerListCenterRight,
  footerListRight,
  footerListBottom,
  fetchFooterLinks,
} = useNavigations();

onMounted(() => {
  if (!props.compact) {
    void fetchFooterLinks();
  }
});
</script>
